import { requestJson } from "./api";

export interface BusinessCenterOperationalStateScope {
  scopeKey?: string;
  scopeType?: "platform" | "company" | "workspace" | "brand";
  companyId?: string | null;
  workspaceId?: string | null;
  brand?: string | null;
  stateKey?: string;
}

export async function loadBusinessCenterOperationalState<T>(moduleKey: string, scope: BusinessCenterOperationalStateScope = {}) {
  const searchParams = new URLSearchParams();
  searchParams.set("moduleKey", moduleKey);
  if (scope.scopeKey) searchParams.set("scopeKey", scope.scopeKey);
  if (scope.scopeType) searchParams.set("scopeType", scope.scopeType);
  if (scope.companyId) searchParams.set("companyId", scope.companyId);
  if (scope.workspaceId) searchParams.set("workspaceId", scope.workspaceId);
  if (scope.brand) searchParams.set("brand", scope.brand);
  if (scope.stateKey) searchParams.set("stateKey", scope.stateKey);
  return requestJson<{ state: T | null; record: unknown }>(`/api/admin/business-center/state?${searchParams.toString()}`);
}

export async function saveBusinessCenterOperationalState<T>(
  moduleKey: string,
  payload: T,
  scope: BusinessCenterOperationalStateScope = {},
) {
  return requestJson<{ state: T; record: unknown }>("/api/admin/business-center/state", {
    method: "POST",
    body: JSON.stringify({
      moduleKey,
      payload,
      ...scope,
    }),
  });
}
